export const matchRoute = (routes, path) =>
  routes.find(item => {
    const pathMatch = [
      '/',
      '/index',
      '/index.html',
      '/ut-launch-slp/index.html',
      '/ut-webx/ut-launch-slp/index.html'
    ].includes(path)

    return pathMatch ? true : item.path.includes(path)
  })

export const getAsyncData = async ({ context, fetch, store, router }) => {
  let fetchData = {}
  if (fetch) {
    const fetchFn = await fetch()
    fetchData = await fetchFn.default({ store, router, fetch }, context)
  }
  return Object.assign({}, fetchData ?? {})
}
